import BenchlingConfig from 'BenchlingConfig';

// Keep in sync with benchling/notebook/structured_tables/export/lookup_config_typed_value.py:get_quantity_display_string
function getQuantityDisplayString(capitalize: boolean = true, pluralize: boolean = false): string {
  const quantityText = pluralize ? 'quantities' : 'quantity';
  const volumeText = pluralize ? 'volumes' : 'volume';
  const resultText = BenchlingConfig.INVENTORY_ENABLE_SOLID_UNITS_FOR_CONTAINER ? quantityText : volumeText;
  return capitalize ? resultText.charAt(0).toUpperCase() + resultText.slice(1) : resultText;
}

export default getQuantityDisplayString;
